import axios from 'axios';

export const getCurrentUser = async () => {
    const url = `/api/v1/user_profile/user`;
    const res = await axios.get(url);
    return res.data;
};

export const getCurrentContracts = async () => {
    const url = `/api/v1/user_profile/user/contracts`;
    const res = await axios.get(url);
    return res.data;
};

export const updateCurrentUser = async (body) => {
    const url = `/api/v1/user_profile/user`;
    const config = body instanceof FormData ? {headers: { "Content-Type": "multipart/form-data" }} : {}
    const res = await axios.patch(url, body, config);
    return res.data;
}

export const updatePassword = async (body) => {
    const url = `/api/v1/user_profile/user/password`;
    const res = await axios.patch(url, body);
    return res.data;
};